<template>
  <eg-modal
    id="rename-folder-modal"
    :title="$t('common.rename') + ' ' + $t('common.class')"
    size="md"
    centered
    class="rename-folder-modal"
  >
    <template #modal-footer="{ close }">
      <div class="d-flex align-items-center justify-content-end">
        <eg-button type="secondary" @click="close">{{
          $t("common.back")
        }}</eg-button>
        <eg-button
          class="ml-2"
          :disabled="!folderName.trim() || loading"
          type="primary"
          :is-loading="loading"
          :loading-text="$t('common.saving')"
          @click="renameFolder"
        >
          {{ $t("common.save") }}
        </eg-button>
      </div>
    </template>

    <div>
      <eg-b-form-group
        :label="$t('common.folderName')"
        label-for="rename-folder-name"
      >
        <eg-b-form-input
          id="rename-folder-name"
          v-model="folderName"
          :placeholder="$t('common.folderNamePlaceholder')"
          type="text"
          autofocus
          @keyup.enter="renameFolder"
        ></eg-b-form-input>
      </eg-b-form-group>
    </div>
  </eg-modal>
</template>

<script>
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import { updateFolder } from "@/api";

export default {
  name: "RenameFolderModal",

  components: {
    EgButton,
  },

  inject: ["workspacesProvider"],

  props: {
    folderId: {
      type: Number,
      default: null,
    },
    workspaceKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      folderName: "",
      loading: false,
    };
  },

  computed: {
    folder() {
      return this.workspacesProvider.getFolderById(
        this.workspaceKey,
        this.folderId
      );
    },
  },

  created() {
    this.folderName = this.folder?.name || "";
  },

  methods: {
    async renameFolder() {
      if (this.folderName.length === 0) {
        this.$showToastError(this.$t("common.folderNameEmpty"));
        return;
      }

      this.loading = true;

      try {
        await updateFolder(this.folder.id, { name: this.folderName });

        this.workspacesProvider.updateFolderById(
          this.workspaceKey,
          this.folder.id,
          {
            id: this.folder.id,
            name: this.folderName,
          }
        );

        this.$showToastSuccess(this.$t("common.folderRenamed"), {
          title: this.$t("common.success"),
        });

        this.$egModal.hide("rename-folder-modal");
      } catch (error) {
        this.$showToastError(this.$t("common.folderRenameFailed"), {
          title: this.$t("common.error"),
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
